registerGlobal( 'EmscriptenBraze' );

var appboy = require( 'appboy-web-sdk' );

var gdprConsentKey = "br_consent"
var keyPrefix = "br_"
var sessionTimeoutKey = "br_timeout"

EmscriptenBraze.initialize = function( apiKey, apiEndpoint, appVersion ) {
    try
    {
        var sendSensitiveData = false;
        try
        {
            sendSensitiveData = localStorage.getItem( gdprConsentKey );
        }
        catch( error )
        {
            console.log( error );
        }

        if( sendSensitiveData == true )
        {
            var options = {
                baseUrl: apiEndpoint,
                appVersion: appVersion
            };
            var sessionTimeout = null;
            try
            {
                sessionTimeout = localStorage.getItem( sessionTimeoutKey );
            }
            catch( error )
            {
                console.log( error );
            }
            if( sessionTimeout != null && sessionTimeout > 0 )
            {
                options.sessionTimeoutInSeconds = sessionTimeout;
            }
            appboy.initialize( apiKey, options );
        }
        else
        {
            EmscriptenBraze.apiKey = apiKey;
            EmscriptenBraze.apiEndpoint = apiEndpoint;
            EmscriptenBraze.appVersion = appVersion;
            EmscriptenBraze.initDelayed = true;
            appboy.stopWebTracking();
        }
    }
    catch( error )
    {
        console.log( error );
    }
};

EmscriptenBraze.login = function( userId ) {
    EmscriptenBraze.userId = userId;
    if( EmscriptenBraze.initDelayed ) return;
    try
    {
        appboy.getUser().getUserId( function( brazeUserId ) {
            if( brazeUserId == EmscriptenBraze.userId ) return;
            try
            {
                appboy.changeUser( EmscriptenBraze.userId );
            }
            catch( error )
            {
                console.log( error );
            }
        } );
    }
    catch( error )
    {
        console.log( error );
    }

    try
    {
        var subscrTypes = appboy.ab.User.NotificationSubscriptionTypes;
        appboy.getUser().setPushNotificationSubscriptionType( subscrTypes.OPTED_IN );
    }
    catch( error )
    {
        console.log( error );
    }
}

EmscriptenBraze.setSessionTimeout = function( seconds ) {
    try
    {
        localStorage.setItem( sessionTimeoutKey, seconds );
    }
    catch( error )
    {
        console.log( error );
    }
};

EmscriptenBraze.logPurchase = function( productId, currencyCode, price, category ) {
    try
    {
        appboy.logPurchase( productId, price, currencyCode, 1, { type: category } );
        appboy.requestImmediateDataFlush();
    }
    catch( error )
    {
        console.log( error );
    }
};

EmscriptenBraze.logCustomEvent = function( eventName ) {
    if( EmscriptenBraze.initDelayed ) return;
    try
    {
        appboy.logCustomEvent( eventName );
    }
    catch( error )
    {
        console.log( error );
    }
};

EmscriptenBraze.updateAttribute = function( key, value ) {
    if( EmscriptenBraze.initDelayed ) return;
    try
    {
        var savedValue = localStorage.getItem( keyPrefix + key );
        if( savedValue == value ) return;
        appboy.getUser().setCustomUserAttribute( key, value );
        localStorage.setItem( keyPrefix + key, value );
    }
    catch( error )
    {
        console.log( error );
    }
};

EmscriptenBraze.updateAttributeTimestamp = function( key, value ) {
    if( EmscriptenBraze.initDelayed ) return;
    try
    {
        var savedValue = localStorage.getItem( keyPrefix + key );
        if( savedValue == value ) return;
        appboy.getUser().setCustomUserAttribute( key, new Date( value * 1000 ) );
        localStorage.setItem( keyPrefix + key, value );
    }
    catch( error )
    {
        console.log( error );
    }
};

EmscriptenBraze.setTracking = function( enabled ) {
    try
    {
        localStorage.setItem( gdprConsentKey, enabled );
        if( enabled && EmscriptenBraze.initDelayed )
        {
            appboy.resumeWebTracking();
            EmscriptenBraze.initialize( EmscriptenBraze.apiKey, EmscriptenBraze.apiEndpoint, EmscriptenBraze.appVersion );
            EmscriptenBraze.initDelayed = false;
            if( EmscriptenBraze.userId ) EmscriptenBraze.login( EmscriptenBraze.userId );
        }
    }
    catch( error )
    {
        console.log( error );
    }
};

EmscriptenBraze.setEmail = function( email ) {
    try
    {
        return appboy.getUser().setEmail( email ) ? 1 : 0;
    }
    catch( error )
    {
        console.log( error );
    }
    return false;
};

EmscriptenBraze.setEmailSubscriptionType = function( type ) {
    try
    {
        var user = appboy.getUser();
        var subscrTypes = appboy.ab.User.NotificationSubscriptionTypes;
        var typesMapping = [ subscrTypes.OPTED_IN, subscrTypes.SUBSCRIBED, subscrTypes.UNSUBSCRIBED ];
        console.log("EmscriptenBraze.setEmailSubscriptionType", type, typesMapping[type]);
        return user.setEmailNotificationSubscriptionType( typesMapping[type] ) ? 1 : 0;
    }
    catch( error )
    {
        console.log( error );
    }
    return false;
};



//////////////////
// WEBPACK FOOTER
// /src/contrib/braze/emscripten/js/Application.braze.js
// module id = 29
// module chunks = 0